import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { HorizontalFlex } from 'smartsuite-ui/lib/containers/HorizontalFlex';
import { brandingVariables } from 'smartsuite-ui/lib/constants/brandingVariables';

const statuses = {
    good: 'good',
    warning: 'warning',
    error: 'error',
};

function formatTimestamp(timestamp) {
    const momentTimestamp = moment(timestamp);

    if (momentTimestamp.isSame(new Date(), 'day')) {
        return momentTimestamp.format('h:mm A');
    }

    return momentTimestamp.format('M/D');
}

// eslint-disable-next-line complexity
function statusColor(status) {
    switch (status) {
        case statuses.good:
            return brandingVariables.success;
        case statuses.warning:
            return brandingVariables.warning;
        case statuses.error:
            return brandingVariables.error;
        default:
            return brandingVariables.accent0;
    }
}

export default function NewsfeedItem({ message, status, subject, timestamp }) {
    const [messageExpanded, setMessageExpanded] = useState(false);

    function toggleMessage() {
        setMessageExpanded((prevState) => !prevState);
    }

    const messageClassName = messageExpanded
        ? 'newsfeed-item__message newsfeed-item__message--expanded'
        : 'newsfeed-item__message';

    return (
        <div className="newsfeed-item" onClick={toggleMessage}>
            <HorizontalFlex cssClassModifiers={['space-between']}>
                <span className="newsfeed-item__subject">{subject}</span>
                <span className="newsfeed-item__timestamp" title={timestamp}>
                    {formatTimestamp(timestamp)}
                </span>
            </HorizontalFlex>
            <HorizontalFlex cssClassModifiers={['space-between']}>
                <span className={messageClassName} title={message}>
                    {message}
                </span>
                <span
                    className="newsfeed-status"
                    style={{
                        backgroundColor: statusColor(status),
                    }}
                />
            </HorizontalFlex>
        </div>
    );
}

NewsfeedItem.propTypes = {
    message: PropTypes.string,
    status: PropTypes.string,
    subject: PropTypes.string,
    timestamp: PropTypes.string,
};
